import { TrustAPI } from "@/shared/modules/trust-api";
import store from "@/trust-admin-app/store";
import { Inject, Options, Vue } from "vue-property-decorator";
import AddEditModal from "./add-edit-modal/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { EventEmitter } from "events";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { AccountView, MortgageInfoRequest, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";

@Options({
  components: {
    AddEditModal,
    LoadingIndicator,
    ErrorIndicator
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticeBank extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  private selectedAccount: AccountView = {};

  private investmentsRegisteredNumber = this.selectedPractice.investmentsRegisteredNumber;
  private contributoryMortgagesNumber = this.selectedPractice.contributoryMortgagesNumber;

  private trustAccTableHeadings = [
    { text: 'BSB no.', value: 'bsbNumber', sortable: false },
    { text: 'Bank', value: 'bank', sortable: false },
    { text: 'Branch', value: 'branch', sortable: false },
    { text: 'Account no.', value: 'accountNumber', sortable: false },
    { text: 'Account name', value: 'accountName', sortable: false },
    { text: 'Opened', value: 'opened', sortable: false },
    { text: 'Closed', value: 'closed', sortable: false },
    { text: 'Action', value: 'action', sortable: false },
  ];

  private generalAccTableHeadings = [
    { text: 'BSB no.', value: 'bsbNumber', sortable: false },
    { text: 'Bank', value: 'bank', sortable: false },
    { text: 'Branch', value: 'branch', sortable: false },
    { text: 'Account no.', value: 'accountNumber', sortable: false },
    { text: 'Account name', value: 'accountName', sortable: false },
    { text: 'Opened', value: 'opened', sortable: false },
    { text: 'Closed', value: 'closed', sortable: false },
    { text: 'Action', value: 'action', sortable: false },
  ];

  private trustAccounts: AccountView[] = [];

  private generalAccounts: AccountView[] = [];

  private generalAccountingSystem = "Some System"

  private showAddEditModal = false;

  private loadingContent = false;
  private errorLoadingContent = false;

  private isEditMortgageInfo = false;
  private isSavingMortgageInfo = false;

  created(): void {
    this.loadTrustAccounts();
  }

  mounted() {
    window.scrollTo(0, 0);
    this.eventCtrl.on('reload-accounting-accounts', this.loadTrustAccounts);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-accounting-accounts', this.loadTrustAccounts);
  }

  private openAddEditAccount(acct: AccountView): void {
    this.selectedAccount = acct;
    this.selectedAccount.practiceId = this.selectedPractice.id;
    this.showAddEditModal = true;
  }

  private closeAddEditAccount(): void {
    this.showAddEditModal = false;
    this.selectedAccount = {};
  }

  private async loadTrustAccounts(): Promise<void> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;
      const resp: any = await this.apiService.AccountApi?.apiV2AccountGetAccountsByPracticeIdPracticeIdGet(this.selectedPractice.id);

      this.trustAccounts = (resp.data.data as AccountView[]).filter(x => x.accountTypeId == 1);
      this.generalAccounts = (resp.data.data as AccountView[]).filter(x => x.accountTypeId == 2);

    } catch (err) {
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  private saveMortgageInfo() {
    this.isEditMortgageInfo = false;
    this.isSavingMortgageInfo = true;

    const _body: MortgageInfoRequest = {
      id: this.selectedPractice.id,
      investmentsRegisteredNumber: this.investmentsRegisteredNumber,
      contributoryMortgagesNumber: this.contributoryMortgagesNumber
    }
    this.apiService.PracticeApi?.apiV2PracticeEditMortgageInfoPost(_body)
      .then(() => {
        this.isSavingMortgageInfo = false;
        this.eventCtrl.emit('show-snackbar', 'success', 'Mortgage information saved');
        this.refreshPractice();
      })
      .catch(err => {
        this.isSavingMortgageInfo = false;
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to save Mortgage information');
        this.ai.trackException('Error, Unable to get signatory list: ' + err);
      })
  }

  private async refreshPractice() {
    await this.apiService.PracticeApi?.apiV2PracticeGetPracticeByIdPracticeIdGet(this.selectedPractice.id)
      .then(res => {
        const practice: PracticeView = res.data.data;
        if (practice) {
          store.dispatch('setSelectedPractice', practice as PracticeView);
        }
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to refresh practice information');
        this.ai.trackException('Error, Unable to refresh practice information: ' + err);
      })
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
}

